import SvgTextToPath from 'svg-text-to-path';
import { smoothPath } from 'svg-smoother';

const selectors = {
  el: '.js-headline:not(.is-initialized)',
};

const onResize = el => {
  const g = el.querySelector('g');
  el.setAttribute('viewBox', `0 0 ${g.getBBox().width + .5} ${g.getBBox().height + 5}`);
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);
  els.forEach(el => {
    el.classList.add('is-initialized');

    const session = new SvgTextToPath(el, {
      split: true,
      keepFontAttrs: true,
      fonts: {
        'OTNeueMontreal Extra Squeezed': [
          {
            wght: 400,
            ital: 0,
            source:
              './src/assets/fonts/OTNeueMontreal-BoldExtraSqueezed.woff2',
          },
        ],
      },
    });

    session.replaceAll().then(() => {
      onResize(el);
      const paths = el.querySelectorAll('path');
      paths.forEach((path) => {
        const d = path.getAttribute('d');
        if (!d.length) return;
        const smoothedPath = smoothPath(d, { radius: 0.2 });
        path.setAttribute('d', smoothedPath);
      });
    });

    window.addEventListener('resize', () => {
      onResize(el);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
